import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";

type ProductListClickedEventProps = {
  listId: string;
  listType: string;
  listFormat: string;
  shopType?: string;
  resultId?: string;
};

export type ProductListClickedEvent = TrackingEvent<
  "Product List Clicked",
  {
    list_id: string;
    list_type: string;
    list_format: string;
    path: string;
    shop_type?: string;
    result_id?: string;
  }
>;

export async function trackProductListClickedEvent({
  listId,
  listType,
  listFormat,
  shopType,
  resultId,
}: ProductListClickedEventProps): TrackingEventResponse {
  const path = typeof window !== "undefined" ? window.location.pathname : "";

  return await trackEvent("Product List Clicked", {
    props: {
      list_id: listId,
      list_type: listType,
      list_format: listFormat,
      path,
      shop_type: shopType,
      result_id: resultId,
    },
    withRequestSource: true,
  });
}
